import { generateId } from '../templateRenderer/utils/generateTemplateIds'
import { TemplateData } from '../types/blueprint'

export const DEFAULT_TEMPLATE: TemplateData = {
  id: generateId('TEMPLATE'),
  sections: [
    {
      id: generateId('SECTION'),
      blockGroups: [
        {
          id: generateId('BLOCK_GROUP'),
          name: '',
          blocks: [],
        },
      ],
    },
  ],
}
